<page-header (showBlockedChanged)="initVideos()"></page-header>

<h1>{{channelTitle}}</h1>

<div class="videos">
<videos *ngIf="videos.length>0" [videos]="videos" ></videos></div>

<div class="loading-div" *ngIf="!dataLoaded">
    <div class="d-flex justify-content-center">
        <div class="spinner-border large-spinner" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <span>אנחנו מחפשים עבורך את הסרטון המתאים...</span>
</div>

<h1 *ngIf="!loading&&!videos.length">לא נמצאו תוצאות</h1>
<div *ngIf="loading&&videos.length>0" class="bottom-spinner">
    <div *ngIf="dataLoaded&&loading" class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>